import { parseAgentSessionKey } from "../../../../src/routing/session-key.js";

/** Agent id that owns files for a gateway session key. */
export function resolveAgentIdForSession(sessionKey: string, defaultAgentId = "main"): string {
  const parsed = parseAgentSessionKey(sessionKey.trim());
  return parsed?.agentId?.trim() || defaultAgentId;
}
